module.exports = __webpack_public_path__ + "4fed469d90afd218104301f111d6782c.svg";